/**
 * A design's story (2026-10-31, the owner: "the history for each card in an info button ... on the
 * screen, not to the print of course"): where the fold comes from, behind the (i) beside each design
 * in "Choose a design". On screen only - nothing here is printed.
 *
 * The words are the strings story_<id>, paragraphs split by a blank line; the dates come from
 * docs/fold-ideas/traditional-models.md and say "recorded", never "invented".
 */
import { useEffect, useRef } from 'react';
import { t, type StringKey } from './strings.ts';

export function DesignStory({ name, story, onClose }: { name: string; story: StringKey; onClose: () => void }) {
  const close = useRef<HTMLButtonElement>(null);
  useEffect(() => {
    close.current?.focus();
    const key = (e: KeyboardEvent) => { if (e.key === 'Escape') onClose(); };
    addEventListener('keydown', key);
    return () => removeEventListener('keydown', key);
  }, [onClose]);
  return (
    <div className="confirm-veil no-print" role="presentation" onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="confirm-dialog story-dialog" role="dialog" aria-modal="true" aria-labelledby="story-title">
        <h2 id="story-title">{t('storyTitle', { name })}</h2>
        {t(story).split('\n\n').map((p, i) => <p key={i}>{p}</p>)}
        <p className="small muted story-source">{t('storySource')}</p>
        <div className="confirm-buttons">
          <button type="button" ref={close} className="primary" onClick={onClose}>{t('close')}</button>
        </div>
      </div>
    </div>
  );
}
